import axios from 'axios';

const getSingleAddressApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/Address/single?address_id=${paramsFilter?.addressId || ''}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getSingleAddressApi;
